import styled from "styled-components";
import { Button } from "./button";
import {
  LittleSubHeadline,
  LittleText,
  SubTitle,
  TextBody,
} from "../typography";
import { boxShadow } from "../components-style";
import { COLORS } from "../../assets/utils/enums/colors";
import Dropdown from "./dropdown";
import { DropdownTypeEnum } from "../../assets/utils/enums/table";
import { useStatisticPeriod } from "../../assets/store/useStatisticPeriod";
export interface DataStatisticProps {
  title: string;
  value: string;
  percent: string;
}

interface StatisticBlockProps {
  iconUrl: string;
  iconColor: string;
  bgColor: string;
  isDropdown?: boolean;
  data?: DataStatisticProps[];
  statsTitle?: string;
}

export default function StatisticBlock(props: StatisticBlockProps) {
  const { period, setPeriod } = useStatisticPeriod();

  return (
    <StatisticBlockStyle
      $bgColor={props.bgColor}
      $itemLength={props.data!.length}
    >
      <div data-type="header" className="">
        <span className="d-flex align-items-center gap-3">
          <Button
            bgcolor={props.iconColor}
            txtcolor={"transparent"}
            brcolor={"transparent"}
            width="40px"
            type="large"
            brradius="12px"
          >
            <>
              {" "}
              <img src={props.iconUrl} alt="user-icon" />
            </>
          </Button>
          <TextBody>{props.statsTitle}</TextBody>
        </span>
        {props.isDropdown && (
          <Dropdown
            checkedValue={period}
            setChecked={
              setPeriod as React.Dispatch<React.SetStateAction<string>>
            }
            type={DropdownTypeEnum.PERIODS}
          />
        )}
      </div>
      <div data-type="body">
        {props.data?.length === 0 ? (
          <SubTitle>Даних не знайдено</SubTitle>
        ) : (
          props.data?.map((item) => (
            <StatisticBodyItem
              key={item.title}
              $percentColor={
                COLORS[
                  `${
                    props.bgColor === COLORS.blue
                      ? "secondary1"
                      : item.percent.includes("+") ||
                        (!item.percent.includes("+") &&
                          !item.percent.includes("-"))
                      ? "main1"
                      : item.percent.includes("-")
                      ? "warning"
                      : "secondary1"
                  }`
                ]
              }
            >
              <LittleSubHeadline>{item.title}</LittleSubHeadline>
              <span className="d-flex flex-row align-items-center flex-wrap justify-content-start">
                <SubTitle>{item.value}</SubTitle>

                {item.percent && <LittleText>{item.percent}</LittleText>}
              </span>
            </StatisticBodyItem>
          ))
        )}
      </div>
    </StatisticBlockStyle>
  );
}

export const StatisticBlockStyle = styled.div<{
  $bgColor: string;
  $itemLength: number;
}>`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  flex-grow: 1;
  background-color: ${({ $bgColor }) => $bgColor};
  color: ${({ $bgColor }) =>
    $bgColor === COLORS.blue ? COLORS.white : COLORS.secondary1};
  padding: 12px 16px;
  border-radius: 12px;
  ${boxShadow("rgba(9, 21, 64, 0.2)")};
  gap: 24px;
  transition: all 200ms cubic-bezier(0.25, 0.1, 0.25, 1);
  cursor: default;
  /* &:active {
      cursor: pointer;
    transform: scale(0.95);
  } */

  * > p {
    white-space: nowrap;
  }

  ${LittleSubHeadline}, ${TextBody} {
    flex-shrink: 0;
    white-space: nowrap;
    color: ${({ $bgColor }) =>
      $bgColor === COLORS.blue ? COLORS.white : COLORS["bg-text-color"]};
  }

  ${SubTitle} {
    color: ${({ $bgColor }) =>
      $bgColor === COLORS.blue ? COLORS.white : COLORS.secondary1};
  }

  [data-type="header"] {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    ${Button} {
      height: 40px;
    }
  }

  [data-type="body"] {
    display: flex;
    align-items: start;
    justify-content: space-between;
    width: 100%;
    gap: 16px;

    span {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 4px;
      min-width: ${({ $itemLength }) => `calc(100% / ${$itemLength} - 10%)`};

      ${LittleText} {
      }
    }
  }
`;

const StatisticBodyItem = styled.span<{
  $percentColor: string;
}>`
  padding: 0 2px;
  ${LittleText} {
    color: ${({ $percentColor }) => $percentColor};
    padding-left: 4px;
  }
`;
